export default __webpack_public_path__ + "static/media/eco3.b301f19a.jpg";